import React from "react";
import moment from "moment";
import Countdown from "../../../../shared/hocs/Countdown";

export class GivingCountdown extends React.Component {
  render() {
    const { countdown, endCountdown, display_countdown } = this.props;

    if (!countdown || !endCountdown || !display_countdown) return null;

    const formattedTime = moment(endCountdown).format("X");

    return (
      <div
        role="timer"
        className="countdown secondary-color-text"
        aria-label="Time remaining until event"
        aria-live="polite">
        <Countdown leadingZeroes={true} endTime={formattedTime}>
          {({ days, hours, minutes, seconds }) => (
            <div>
              <span>
                <strong
                  className="primary-color-text"
                  aria-label="Days remaining"
                  aria-live="polite">
                  {days}
                </strong>
                D
              </span>
              <span>
                &nbsp;
                <strong
                  className="primary-color-text"
                  aria-label="Hours remaining"
                  aria-live="polite">
                  {hours}
                </strong>
                H
              </span>
              <span>
                &nbsp;
                <strong
                  className="primary-color-text"
                  aria-label="Minutes remaining"
                  aria-live="polite">
                  {minutes}
                </strong>
                M
              </span>
              <span>
                &nbsp;
                <strong className="primary-color-text" aria-label="Seconds remaining">
                  {seconds}
                </strong>
                S
              </span>
            </div>
          )}
        </Countdown>
      </div>
    );
  }
}

export default GivingCountdown;
